export const showParkingInProgressPopUpSelector = ({showParkingInProgressPopUp}) => showParkingInProgressPopUp